const BaseModule = require('../../../90_utils/base/BaseModule');

class Mission extends BaseModule {

	constructor(el, params){

		super(el);

		this.$logos = this.$el.find('.logos .logo');
		this.interval;
	}

	_domReady(){

		this.$arrows = this.$el.find('svg #right-arrow, svg #left-arrow');
		this.$el.find('.logo').addClass('is-out');
	}

	_addListeners(){
		this.$el.find('.logo a').on('click', $.proxy(this._onButtonClick, this));
		this.$el.find('.logo a').on('mouseenter', $.proxy(this._onButtonClick, this));
		this.$el.find('.logo a').on('mouseleave', $.proxy(this._onButtonLeave, this));
	}

	_removeListeners(){
		this.$el.find('.logo a').off('click', $.proxy(this._onButtonClick, this));
		this.$el.find('.logo a').off('mouseenter', $.proxy(this._onButtonHover, this));
		this.$el.find('.logo a').off('mouseleave', $.proxy(this._onButtonLeave, this));
		$('body').off('click', $.proxy(this._onOut, this));
	}

	//

	_onButtonClick(e){

		e.stopImmediatePropagation();

		let $target = $(e.currentTarget);
		let $logo = $target.closest('.logo');

		this.$logos.each((index, value) => {
			let $value = $(value);
			if($value[0] !== $logo[0]){
				$value.removeClass('is-active is-out');
			}
		});

		if($logo.hasClass('is-active')){
			$logo.removeClass('is-active is-out');
		}
		else {
			$logo.addClass('is-active');
			$logo.removeClass('is-out');
		}

		window.SETTINGS.animationFrame.one(() => {
			$('body').off('click', $.proxy(this._onOut, this));
			$('body').on('click', $.proxy(this._onOut, this));
		});
	}

	_onButtonLeave(e){

		if(e.stopImmediatePropagation){
			e.stopImmediatePropagation();
		}

		let $target = $(e.currentTarget);
		let $logo = $target.closest('.logo');

		$logo.addClass('is-out');
		$logo.removeClass('is-active');

		$('body').off('click', $.proxy(this._onOut, this));
	}

	_onOut(e){
		e.stopImmediatePropagation();
		this._onButtonLeave({currentTarget:this.$el.find('.is-active')});
	}

	//

	_show(){

		// arrows animation

		/*

		let $arrowright = this.$el.find('svg #arrow-right');
		let $arrowrightstem = $arrowright.find('path');
		let $arrowrightcap = $arrowright.find('polyline');
		let arrowrightStemLen = $arrowrightstem.get(0).getTotalLength();
		let arrowrightCapLen = $arrowrightcap.get(0).getTotalLength();

		let $arrowleft = this.$el.find('svg #arrow-left');
		let $arrowleftstem = $arrowleft.find('path');
		let $arrowleftcap = $arrowleft.find('polyline');
		let arrowleftStemLen = $arrowleftstem.get(0).getTotalLength();
		let arrowleftCapLen = $arrowleftcap.get(0).getTotalLength();

		$arrowrightstem.attr({ 'stroke-dasharray': arrowrightStemLen, 'stroke-dashoffset': arrowrightStemLen });
		$arrowleftstem.attr({ 'stroke-dasharray': arrowleftStemLen, 'stroke-dashoffset': (arrowleftStemLen * -1) });

		// TweenMax.set($arrowleftcap, { opacity: 0 });
		// TweenMax.set($arrowrightcap, { opacity: 0 });

		let tweenObjLeft = { len: (arrowleftStemLen * -1) };
		let tweenObjRight = { len: (arrowrightStemLen * -1) };

		TweenMax.to(tweenObjLeft, 2.5, {
			len: arrowleftStemLen,
			ease: 'fade',
			repeat: -1,
			onUpdate: ()=>{
				$arrowleftstem.attr({ 'stroke-dashoffset': tweenObjLeft.len });
			},
			onRepeat: ()=>{
				$arrowleftstem.attr({ 'stroke-dasharray': arrowleftStemLen, 'stroke-dashoffset': (arrowleftStemLen * -1) });
			}
		});

		// TweenMax.to($arrowleftcap, 0.6, {
		// 	opacity: 1,
		// 	ease: 'fade',
		// 	yoyo: true,
		// 	repeat: -1,
		// 	repeatDelay: 0.5
		// });

		//

		TweenMax.to(tweenObjRight, 2.5, {
			len: arrowrightStemLen,
			ease: 'fade',
			repeat: -1,
			onUpdate: ()=>{
				$arrowrightstem.attr({ 'stroke-dashoffset': tweenObjRight.len });
			},
			onRepeat: ()=>{
				$arrowrightstem.attr({ 'stroke-dasharray': arrowrightStemLen, 'stroke-dashoffset': arrowrightStemLen });
			}
		});

		// TweenMax.to($arrowrightcap, 0.6, {
		// 	opacity: 1,
		// 	ease: 'fade',
		// 	yoyo: true,
		// 	repeat: -1,
		// 	repeatDelay: 0.5
		// });

		*/
	}
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = Mission;
